import { useTranslation } from 'react-i18next';

interface ConfirmationCardProps {
  data: {
    title: string;
    description: string;
    details?: Record<string, unknown>;
    confirm_label?: string;
    cancel_label?: string;
  };
  onSelect: (selection: Record<string, unknown>) => void;
}

export function ConfirmationCard({ data, onSelect }: ConfirmationCardProps) {
  const { t } = useTranslation();

  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden my-2">
      <div className="p-4">
        <h3 className="text-sm font-semibold text-gray-900 mb-1">{data.title}</h3>
        <p className="text-sm text-gray-600 mb-3">{data.description}</p>

        {data.details && (
          <div className="bg-gray-50 rounded-lg p-3 mb-3 text-xs text-gray-600">
            {Object.entries(data.details).map(([key, value]) => (
              <div key={key} className="flex justify-between py-0.5">
                <span className="text-gray-500">{key}:</span>
                <span className="font-medium">{String(value)}</span>
              </div>
            ))}
          </div>
        )}

        <div className="flex gap-2">
          <button
            onClick={() => onSelect({ confirmed: true })}
            className="flex-1 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 transition-colors"
          >
            {data.confirm_label || t('common.confirm', 'Confirm')}
          </button>
          <button
            onClick={() => onSelect({ confirmed: false })}
            className="flex-1 py-2 bg-gray-200 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-300 transition-colors"
          >
            {data.cancel_label || t('common.cancel', 'Cancel')}
          </button>
        </div>
      </div>
    </div>
  );
}
